import TravelZonePlaylist from './TravelZonePlaylist';

export default TravelZonePlaylist;
